export default class DtoCampaignProgress {
    constructor(obj) {
        this.id = obj.id
        this.nbStation = obj.nbStation
        this.nbValidatedStation = obj.nbValidatedStation
        this.nbStationValidated = obj.nbValidatedStation // fix
        this.incompleteStations = obj.incompleteStations
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.progress = obj.progress
        this.progressTotal = obj.progressTotal
        this.nbDoneEvents = obj.nbDoneEvents
        this.nbNotDoneEvents = obj.nbNotDoneEvents
    }
}